<template>
  <div class="user-center__main-page-header">
    <div class="header__title">
      <slot name="title"></slot>
    </div>
    <div class="header__hint">
      <slot name="hint"></slot>
    </div>
    <div class="header__bt">
      <slot name="bt"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-page-header',
};
</script>

<style></style>
